module.exports = __webpack_public_path__ + "img/2010 winteressen 002.245a71ff.jpg";